<template>
	<section>
		<PageLoading v-if="loading" />
		<iframe v-if="klarnaIframeSrc"
			id="dibs-iframe"
			class="payment__iframe"
			:src="klarnaIframeSrc"
			frameborder="0"
		></iframe>
	</section>
</template>
<script>
import store from '../vueX/store'
import PageLoading from '../components/atoms/PageLoading'


export default {
	name: 'Payment',
	store,
	components: {
		PageLoading,
	},
	data() {
		return {
			loading: false,
			summary: null,
			klarnaIframeSrc: '',
			cartitems: []
		}
	},
	created: function () {
		this.loading = true
		let cartWithUserId = Object.assign({}, store.state.cart)

		cartWithUserId.customerlid = store.state.user.id

		store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST')
		.then(response => {
			if (response) {

				store.dispatch('GET_PAYMENT', cartWithUserId)
				.then(success => {
					if (success) {
						this.klarnaIframeSrc = success.paymenturl
						store.dispatch('GET_CONFROMATION_ID', success.paymenturl)
						store.dispatch('EMPTY_CART')
						this.loading = false
					} else {
						this.$router.push({ name: 'cart' })
					}
				})
				
			} else {
				this.loading = false
			}
		})
	}
}
</script>

<style scoped lang="scss">
.payment {
	margin-top: 60px;
	&__accommodation {
		display: flex;
		background-color: #f9f9f9;
		flex-wrap: wrap;
		div {
			flex: 1 1 33%;
		}
	}
	&__wrapper {
		display: flex;
		align-items: center;
		padding: 0px 10px;
	}
	&__title {
		font-size: 22px;
	}
	&__addon-title {
		background-color: rgb(116, 128, 151);
		color: #fff;
		padding: 10px;
		font-size: 18px;
	}
	&__addon {
		display: flex;
		height: 50px;
		align-items: center;
		flex-wrap: wrap;
		padding: 0px 10px;
		> div {
			flex: 1 1 33%;
		}
	}
	&__price {
		text-align: right;
	}
	&__total-price {
		font-size: 32px;
		border-top: 1px solid #e8e8e8;
		text-align: right;
		padding: 10px;
		margin: 10px 0;
	}
	&__iframe {
		width: 100%;
		height: calc(100vh - 64px);
	}
}
</style>
